import { SearchTypeEnum } from 'Enum/SearchTypeEnum';
import { store } from 'Store';

export const addImposterToUrl = (
  baseUrl: string,
  addQuestionMark?: boolean,
) => {
  const imposterType = store.getState().imposter.imposterType;

  const imposterId = store.getState().imposter.imposterId;

  let url = baseUrl;
  if (imposterType === SearchTypeEnum.ID && imposterId) {
    url = `${baseUrl}${addQuestionMark ? '?' : '&'}isrId=${imposterId}`;
  } else if (imposterType === SearchTypeEnum.CaseNumber && imposterId) {
    url = `${baseUrl}${addQuestionMark ? '?' : '&'}caseNumber=${imposterId}`;
  }
  return url;
};
